import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IService } from "@tci/common";
import { NgUiDiscovery } from "../ng-shared/ng-services/ng-ui-discovery";

@Injectable()
export class TCITenantRemoteServices {
    private static instance: TCITenantRemoteServices;

    public static getInstance(discoveryService: NgUiDiscovery) {
        if (!TCITenantRemoteServices.instance) {
            TCITenantRemoteServices.instance = new TCITenantRemoteServices(discoveryService);
        }
        return TCITenantRemoteServices.instance;
    }

    public constructor(private discoveryService: NgUiDiscovery) {
    }

    /**
     * Gets Remote Services
     * It shares the request if a previous one has not finished
     * @param includeLocal
     * @return @Observable<IService[]>
     */
    public getRemoteServices(includeLocal: boolean = false): Observable<IService[]> {
        return this.discoveryService.getRemoteServices(includeLocal);
    }
}
